import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import NestedRoute from '../../../shared/components/tabs/NestedRoute';
import { RootState } from '../../../store';
import { PayerInitialState } from '../../../store/models/payerListModel';
import { getMappedRoute } from '../../../utils/routeUtility';
import CONTROL_CONFIG_BASED_ON_PAYER from '../../../config/formControlConfig';
import { updateFormControlConfig } from '../../../store/actions/payerListAction';
import { REIMBURSEMENT_HOME_NESTED_ROUTE } from '../../../config/route/NestedRoutesConfig';

const Home = ({ match, location }: any): ReactElement => {
  const dispatch = useDispatch();

  const {
    payer, defaultControlConfig,
  } = useSelector((state: RootState): PayerInitialState => state.payerList);
  const { name } = payer || {};

  useEffect((): void => {
    const payerFormControlConfig = (CONTROL_CONFIG_BASED_ON_PAYER[name] || {}); // Set to default RI config

    const newFormControlConfig = { ...defaultControlConfig, ...payerFormControlConfig };
    dispatch(updateFormControlConfig(newFormControlConfig));
  }, [payer, name, updateFormControlConfig, defaultControlConfig]);

  const nextDefaultPage = getMappedRoute(location?.pathname, REIMBURSEMENT_HOME_NESTED_ROUTE())
                           || REIMBURSEMENT_HOME_NESTED_ROUTE()[0].routeName;

  return <NestedRoute
    match={match}
    defaultPage={nextDefaultPage}
    nestedNav={REIMBURSEMENT_HOME_NESTED_ROUTE()}
  />;
};

export default Home;
